import { PropsWithChildren } from "react";

const SelskabsblankettenProvider = ({ children }: PropsWithChildren) => (
  <div className="selskabsblanketten-feature">{children}</div>
);

export default SelskabsblankettenProvider;
